const DEFAULT_FLAGS_BASE = 'https://assets.aleacloud.de/platform/flags';

export type FlagFormat = '1x1' | '4x3';

/**
 * Returns the base URL for flag images (includes format path).
 * Uses VITE_FLAGS_BASE_URL when set, else default. Appends /1x1 or /4x3.
 */
export const getFlagBaseUrl = (format: FlagFormat = '1x1'): string => {
  const base = (import.meta.env.VITE_FLAGS_BASE_URL as string) || DEFAULT_FLAGS_BASE;
  return `${base.replace(/\/$/, '')}/${format}`;
};

export interface GetFlagUrlOptions {
  format?: FlagFormat;
  /** Map language code 'en' to country code 'GB' for flag lookup */
  mapEnToGb?: boolean;
}

/**
 * Returns the flag image URL for a given ISO2 country code or language code.
 * @param code - ISO2 country code (e.g. 'DE', 'GB') or language code (e.g. 'en')
 * @param options - format: '1x1' | '4x3', mapEnToGb: map 'en' -> 'GB' for language switcher
 */
export const getFlagUrl = (
  code: string,
  options: GetFlagUrlOptions = {}
): string => {
  const { format = '1x1', mapEnToGb = false } = options;
  const countryCode = mapEnToGb && code === 'en' ? 'GB' : code.toUpperCase();
  return `${getFlagBaseUrl(format)}/${countryCode.toLowerCase()}.svg`;
};
